// 누적 통계, 
// 월 통계 
export function Stat() {
    return null;
}